const StoryCardLoader = () => {
  return (
    <p>Loading story card...</p>
  );
}
 
export default StoryCardLoader;